import { Box, FormControl, MenuItem, MenuProps, Select } from "@mui/material";
import { SASDashboardSelectStyles, SASSMenuPropsStyles } from "../../ui/styles/inputStyles";
import { ETimePeriods } from "../enums/timesheets.enum";

export const WorkforcePeriodSelector = ({ period, setPeriod }: { period: ETimePeriods, setPeriod: (period: ETimePeriods) => void }) => {
    return (
        <Box
            sx={{
                mb: 4,
            }}
        >
            <FormControl size="small" sx={{ minWidth: 120 }} variant="outlined">
                <Select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value as ETimePeriods)}
                    displayEmpty
                    sx={SASDashboardSelectStyles}
                    MenuProps={SASSMenuPropsStyles as Partial<MenuProps>}
                >
                    <MenuItem value={ETimePeriods.WEEKLY}>Weekly</MenuItem>
                    <MenuItem value={ETimePeriods.MONTHLY}>Monthly</MenuItem>
                    <MenuItem value={ETimePeriods.QUARTERLY}>Quarterly</MenuItem>
                    <MenuItem value={ETimePeriods.YEARLY}>Yearly</MenuItem>
                </Select>
            </FormControl>
        </Box>
    )
}
